export enum DatiqOptimizelyAudienceAttributes {
    UserId = 'user_id',
    UserName = 'user_name',
    OfficeId = 'office_id',
    UserEmail = 'user_email'
}
